import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Paper } from '@material-ui/core'
import { range, find, get } from 'lodash'
import DataFilters from '../../../DataFilters'
import { round } from '../../../../../../helpers'
import Select from 'react-select'
import axios from 'axios'
import ProjectedHeadCountReport from './ProjectedHeadCountReport'
import { useStyles } from '../../styles'


export default function ProjectedHeadCountDetail(props) {

	const classes = useStyles()
	const [workforceData, setWorkforceData] = useState({})
	const [applyFilter, setApplyFilter] = useState(false)
	useEffect(() => {
		if (props.selectedForecast) {
			axios.post(`/api/workforce_forecast/filters/${props.selectedForecast.value}`, props.reportFilters)
				.then((result) => {
					const categoryToDataMap = {}
					result.data.data.forEach(d => {
						if (!categoryToDataMap[d.job_grade]) {
							categoryToDataMap[d.job_grade] = { hierarchy: d.hierarchy, employeesCount: d.employees_count }
						} else {
							categoryToDataMap[d.job_grade] = { hierarchy: d.hierarchy, employeesCount: categoryToDataMap[d.job_grade].employeesCount + d.employees_count }
						}
					})
					setWorkforceData(categoryToDataMap)
				})
				.catch((error) => {
					console.log(error)
					setWorkforceData([])
				})
		}
	}, [props.selectedForecast, applyFilter])

	const onApply = (filters) => {
		props.onApply(filters, 'WorkforceProjectedHeadCountDetails')
	}

	const groups = ['E', 'M', 'P', 'S']

	const groupsNames = {
		'E': 'Executive (E)',
		'M': 'People Mgmt (M)',
		'P': 'Professional IC (P)',
		'S': 'Support (S)',
	}

	const levelsData = []
	const groupSummary = {}
	let currentTotalN = 0

	groups.forEach(g => {
		groupSummary[g] = {
			current: { total: 0, percent: 0 },
			growth: { total: 0, percent: 0 },
			future: { total: 0, percent: 0 },
		}
	})

	range(14).forEach(level => {
		const levelData = props.masterData.jobGrades.filter(hd => hd.hierarchy === level)
		const groupData = {}
		groups.forEach(g => {
			groupData[g] = {
				level: '',
				title: '',
				current: { n: '', percent: '' },
				growth: { n: '', percent: '' },
				future: { n: '', percent: '' },
			}
		})

		levelData.forEach(ld => {
			const groupKey = ld.job_grade.slice(0, 1)
			const dataInReport = find(props.reportData, { 'compkit_job_grade': ld.job_grade })
			const dataInWorkforce = get(workforceData, ld.job_grade, null)
			groupData[groupKey].level = ld.job_grade
			groupData[groupKey].title = ld.job_title

			groupData[groupKey].current.n = dataInReport ? dataInReport.total : 0
			groupData[groupKey].growth.n = 0
			groupData[groupKey].future.n = dataInReport ? dataInReport.total : 0

			if (dataInWorkforce) {
				groupData[groupKey].growth.n = dataInWorkforce.employeesCount
				groupData[groupKey].future.n = groupData[groupKey].current.n + groupData[groupKey].growth.n
			}

			groupSummary[groupKey].current.total = round(groupSummary[groupKey].current.total + groupData[groupKey].current.n)
			groupSummary[groupKey].growth.total = round(groupSummary[groupKey].growth.total + groupData[groupKey].growth.n)
			groupSummary[groupKey].future.total = round(groupSummary[groupKey].future.total + groupData[groupKey].future.n)

		})
		levelsData.push(groupData)
	})

	levelsData.forEach(level => {
		groups.forEach(group => {
			if (level[group].current.n !== '') {
				level[group].current.percent = round((level[group].current.n / groupSummary[group].current.total) * 100)
				level[group].growth.percent = round((level[group].growth.n / groupSummary[group].growth.total) * 100)
				level[group].future.percent = round((level[group].future.n / groupSummary[group].future.total) * 100)
				groupSummary[group].current.percent = round(groupSummary[group].current.percent + level[group].current.percent)
				groupSummary[group].growth.percent = round(groupSummary[group].growth.percent + level[group].growth.percent)
				groupSummary[group].future.percent = round(groupSummary[group].future.percent + level[group].future.percent)
			}
		})
	})

	Object.keys(groupSummary).forEach(key => {
		currentTotalN += groupSummary[key].current.total
		groupSummary[key].current.percent = round(groupSummary[key].current.percent, 0)
		groupSummary[key].growth.percent = round(groupSummary[key].growth.percent, 0)
		groupSummary[key].future.percent = round(groupSummary[key].future.percent, 0)

	})

	levelsData.forEach(level => {
		groups.forEach(group => {
			if (level[group].current.n !== '') {
				level[group].current.percent = level[group].current.percent.toFixed(1)
				level[group].growth.percent = level[group].growth.percent.toFixed(1)
				level[group].future.percent = level[group].future.percent.toFixed(1)
			}
		})
	})


	return (
		<Paper className={classes.root}>
			<DataFilters
				fetchedFilterData={props.fetchedFilterData}
				filtersData={props.filtersData}
				onDataFilterSelect={props.onDataFilterSelect}
				componentName={'WorkforceProjectedHeadCountDetails'}
				reportFilters={props.reportFilters}
				onApply={onApply}
				resetFilter={props.resetFilter}
				setApplyFilters={setApplyFilter}
				applyFilters={applyFilter}
				reportFiltersType={props.reportFiltersType}
				reportDataChanged={props.reportDataChanged}
			/>
			<div className={classes.forecastSelectionArea}>
				{/* <Typography display='inline'>Select Hiring Forecast</Typography> */}
				<Select
					placeholder={'Select Existing Forecast'}
					value={props.selectedForecast}
					onChange={(selectedForecastOption) => props.forecastSelectionChanged('workforceProjectedDetails', selectedForecastOption)}
					options={props.forecastOptions}
				/>
			</div>
			<ProjectedHeadCountReport
				groups={groups}
				groupSummary={groupSummary}
				groupsNames={groupsNames}
				levelsData={levelsData}
				currentTotalN={currentTotalN}
			/>
		</Paper>
	)
}

ProjectedHeadCountDetail.propTypes = {
	masterData: PropTypes.object.isRequired,
	onDataFilterSelect: PropTypes.func.isRequired,
	reportFilters: PropTypes.object.isRequired,
	reportData: PropTypes.array.isRequired,
	onApply: PropTypes.func.isRequired,
	forecastOptions: PropTypes.array.isRequired,
	selectedForecast: PropTypes.object,
	forecastSelectionChanged: PropTypes.func.isRequired,
}
